import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Editor from "@/components/Editor";
import { Tabs, Tab } from "@mui/material";
import { CustomTabPanel } from "@/components/CustomTabPanel";
import { TextInput, useInput } from "react-admin";
var CustomRichTextEditor = function (_a) {
    var source = _a.source;
    var field = useInput({ source: source }).field;
    var editorRef = useRef(null);
    function handleHtmlChange() {
        if (editorRef.current) {
            field.onChange(editorRef.current.getContent());
        }
    }
    return _jsx(Editor, { editorRef: editorRef, value: field.value, onEditorChange: handleHtmlChange });
};
export default function EmailEditEditor(_a) {
    var sourceSubject = _a.sourceSubject, sourceBodyHTML = _a.sourceBodyHTML, sourceBodyPlainText = _a.sourceBodyPlainText;
    var t = useTranslation().t;
    var _b = useState(0), tab = _b[0], setTab = _b[1];
    var changeTab = function (_event, newValue) {
        setTab(newValue);
    };
    return (_jsxs(_Fragment, { children: [sourceSubject && (_jsx(TextInput, { label: String(t("emailEditor.subject")), source: sourceSubject })), _jsxs(Tabs, { value: tab, onChange: changeTab, children: [sourceBodyHTML && (_jsx(Tab, { label: String(t("emailEditor.tabs.richtext")), id: "richtext" }, "richtext")), sourceBodyPlainText && (_jsx(Tab, { label: String(t("emailEditor.tabs.plaintext")), id: "plaintext" }, "plaintext"))] }), sourceBodyHTML && (_jsx(CustomTabPanel, { value: tab, index: 0, children: _jsx(CustomRichTextEditor, { source: sourceBodyHTML }) }, "richtext")), sourceBodyPlainText && (_jsx(CustomTabPanel, { value: tab, index: sourceBodyHTML ? 1 : 0, children: _jsx(TextInput, { label: String(t("emailEditor.tabs.plaintext")), source: sourceBodyPlainText, multiline: true, minRows: 6, maxRows: 20 }) }, "plaintext"))] }));
}
